import React from 'react'
import { BrowserRouter, Route, Routes  } from 'react-router-dom';
import Course from './Course'
import NotFound from './NotFound';
import App from '../App';
import Theory from './Theory';
import Quiz from './Quiz';

const RouterPage = () =>{
    return(
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<App/>} />
                <Route path='/course' element={<Course/>} />
                <Route path='/theory' element={<Theory/>} />
                <Route path='/quiz' element={<Quiz/>} />
                <Route element={NotFound}/>
            </Routes>
        </BrowserRouter>
    )
}

export default RouterPage
